import { render } from "./volunteerManagement.vue?vue&type=template&id=3d0b1cd1"
import script from "./volunteerManagement.vue?vue&type=script&lang=js"
export * from "./volunteerManagement.vue?vue&type=script&lang=js"

import "./volunteerManagement.vue?vue&type=style&index=0&id=3d0b1cd1&lang=less"
script.render = render

export default script